import { icons } from './NavbarHelixIcons.js';

const NavbarHelixIcon = ({ iconName }) => {
    return icons[iconName] || null;
};

export { NavbarHelixIcon };
//# sourceMappingURL=NavbarHelixIcon.js.map
